import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { namespace } from '@/modules/driver/namespace';

import { updateDriver } from '../actions';

interface IParams {
  driverId?: string;
  isActive: boolean;
}

const changeContractStatus = createAsyncThunk(
  `${namespace}/change-contract-status`,
  async ({ driverId, isActive }: IParams, { dispatch }) => {
    if (!driverId) {
      return undefined;
    }

    const driver = await driverAPI.changeContractStatus(driverId, isActive);

    if (driver) {
      dispatch(
        updateDriver({
          id: driver.id,
          update: { hasContractWithPartner: driver.hasContractWithPartner },
        }),
      );
    }

    return driver;
  },
);

export { changeContractStatus };
